import React from 'react';
import { ArrowRotateLeftIcon, VideoSlashIcon } from 'components/icons';

export type VideoUnavailableProps = {
  retry: () => void;
};

export function VideoUnavailable(
  props: VideoUnavailableProps,
): React.ReactElement {
  const { retry } = props;

  return (
    <div className="odin-relative odin-h-full odin-w-full">
      <div className="odin-flex odin-h-full odin-flex-col odin-items-center odin-justify-center">
        <VideoSlashIcon className="odin-mb-2 odin-h-6 odin-w-6 odin-text-slate-400" />
        <p className="odin-text-md odin-text-slate-500">Video unavailable</p>
      </div>
      {!!retry && (
        <button
          type="button"
          onClick={retry}
          className="odin-absolute odin-bottom-3 odin-left-1/2 odin-flex -odin-translate-x-1/2 odin-items-center odin-gap-1 odin-text-sm odin-text-slate-500 hover:odin-text-slate-700"
        >
          <ArrowRotateLeftIcon className="odin-h-3.5 odin-w-3.5" />
          Retry
        </button>
      )}
    </div>
  );
}
